import React from 'react';

interface PoolIconProps {
  className?: string;
}

const PoolIcon: React.FC<PoolIconProps> = ({ className = "w-6 h-6" }) => {
  return (
    <svg 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      className={className}
    >
      {/* Pool border */}
      <rect x="2" y="6" width="20" height="12" rx="2" />
      {/* Water waves */}
      <path d="M5 11 Q7 9, 9 11 Q11 13, 13 11 Q15 9, 17 11 Q19 13, 21 11" />
      <path d="M5 15 Q7 13, 9 15 Q11 17, 13 15 Q15 13, 17 15" />
      {/* Ladder */}
      <path d="M4 6 L4 2" />
      <path d="M7 6 L7 2" />
      <path d="M4 3 L7 3" />
    </svg>
  );
};

export default PoolIcon;
